<template>
    <div class="row-fill container-row">
      <div class="col-fill container-col">
        <h1 class="row-fit">
          <router-link :to="'/' + lempos">{{lemma}}</router-link>
          <span class="subtitle">
             تقييم المتواردات اللفظية على شكل
             <em> {{ pattern }} </em>
          </span>
        </h1>
        <div class="col-fill colls-table">
          <b-table class="w-100" hover :items="collocations" :fields="fields" :sort-by="sortBy" :sort-desc="sortDesc">
            <template v-slot:cell(citation_form)="data">
              <router-link :to="{ name: 'review', params: { lempos, qualifiedPattern: makeQualifiedPattern(pattern, coreIndexes), collLempos: data.item.lempos_string} }">
                <span :class="getRatingClass(data.item)">
                  {{data.value.join(' ')}}
                </span>
              </router-link>
              <b-link @click.stop="rateCollocation(data.item, false)"> 𐄂 </b-link>
              <b-link @click.stop="rateCollocation(data.item, true)"> 🗸 </b-link>
            </template>
            <template v-slot:cell(freq)="data">
              {{ arabizeNumerals(data.value) }}
            </template>
          </b-table>
        </div>
      </div>
      <collocation-details v-if="collLempos" :lempos="collLempos" :pattern="pattern" class="col-fit side-pane"/>
    </div>
</template>

<script>
import { api } from '../mixins/api.js'
import CollocationDetails from '../components/CollocationDetails.vue'
import QualifiedPattern from '../components/QualifiedPattern.vue'

export default {
  name: 'ReviewView',
  mixins: [api],
  data: function () {
    return {
      collocations: [],
      fields: [
        { key: 'citation_form', label: 'المتواردة', sortable: true },
        { key: 'freq', label: 'تردد', sortable: true }
      //  { key: 'score', label: 'تقييم', sortable: true }
      ],
      sortBy: 'freq',
      sortDesc: true
    }
  },
  props: {
    lempos: String,
    pattern: String,
    coreIndexes: Array,
    collLempos: String
  },
  components: {
    CollocationDetails,
    QualifiedPattern
  },
  created: function () {
    var t = this
    this.getCollocations({lempos: this.lempos, pattern: this.pattern, coreIndexes: this.coreIndexes}).then(function (response) {
      t.collocations = response.data
    })
  },
  computed: {
    lemma: function () { return this.lempos.split('+')[0] }
  },
  methods: {
    selectCollocation: function (c) { return this.$store.commit('selectCollocation', c) },
    rateCollocation: function (c, isGood) {
      // FIXME: PatternView is not using store ...
      var cc = this.collocations.find((cc) => cc.lempos === c.lempos && cc.pattern === c.pattern)
      // The property "rating" might not have benn present; make it reactive
      this.$set(cc, 'rating', isGood)

      this.$store.dispatch('rateCollocation', { lempos: c.lempos_string, pattern: c.pattern, isGood })
    },
    getRatingClass: function (c) {
      if ('rating' in c) {
        return c.rating ? 'correct' : 'incorrect'
      }
      return 'unknown'
    }

  }
}
</script>

<style scoped>
  .correct {
    color: green
  }
  .incorrect {
    color: red
  }
  .subtitle em {
    color: darkslategrey;
    font-style: normal
  }
  .colls-table {
    padding: 10px;
  }
    a:link, a:visited {
    color:black
  }
  .router-link-active {
    color:black;
    font-weight: bold
  }
</style>
